module.exports = __webpack_public_path__ + "static/media/table.2bc98962.jpg";